import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SwitchLeftIcon from '@mui/icons-material/SwitchLeft';
import SwitchRightIcon from '@mui/icons-material/SwitchRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import Grid from '@mui/material//Grid';
import ListItem from '@mui/material//ListItem';
import ListItemIcon from '@mui/material//ListItemIcon';
import ListItemText from '@mui/material//ListItemText';
import Paper from '@mui/material//Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import { ThemedCheckbox } from '@themes/defaultThemeProps';
import Button from 'components/CustomButtons/Button.js';
import * as React from 'react';

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TemplateSelector(props) {
  var initialLeft = [];
  for (var i = 0; i < props.dictionary.length; i++) initialLeft.push(i);
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(initialLeft);
  const [right, setRight] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const handleAddParameters = async () => {
    var params = [];
    for (var i = 0; i < right.length; i++)
      params.push({ ...props.dictionary[right[i]], key: i });
    props.handleAdd(params);
    props.handleClose();
  };

  const customList = (items) => {    
    const groupedItems = items.reduce((acc, value) => {
      const category = props.dictionary[value].category;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(value);
      return acc;
    }, {});

    const sortedCategories = Object.keys(groupedItems).sort();

    return (
      <Paper
      sx={{ width: '100%', maxHeight: 500, minHeight: 300, overflowY: 'auto' }}
    >
      {sortedCategories.map((category) => (
        <Accordion key={category} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${category}-content`}
            id={`${category}-header`}
          >
            <h5>{category}</h5>
          </AccordionSummary>
          <AccordionDetails>
            <List dense component='div' role='list'>
              {groupedItems[category]
                .sort((a, b) => {
                  const nameA = props.dictionary[a].name.toUpperCase();
                  const nameB = props.dictionary[b].name.toUpperCase();
                  if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }
                  return 0;
                })
                .map((value) => {
                  const labelId = `transfer-list-item-${value}-label`;
                  return (
                    <ListItem
                      key={value}
                      role='listitem'
                      button
                      onClick={handleToggle(value)}
                    >
                      <ListItemIcon>
                        <ThemedCheckbox
                          checked={checked.indexOf(value) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        id={labelId}
                        primary={props.dictionary[value].name}
                        secondary={props.dictionary[value].description}
                      />
                    </ListItem>
                  );
                })}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  )};

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby='form-dialog-title'
        fullWidth={true}
        maxWidth='lg'
      >
        <DialogTitle id='form-dialog-title'>
          Select Templates to Add to Set
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={2}
            justifycontent='center'
            alignItems='stretch'
          >
            <Grid item xs={4}>
              <h5>Default Templates</h5>
              {customList(left)}
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                direction='column'
                alignItems='center'
                spacing={2}
              >
                <Grid item xs={12}>
                  <h5>Actions</h5>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    size='md'
                    fullWidth={true}
                    onClick={handleAllRight}
                    disabled={left.length === 0}
                    color='primary'
                    aria-label='move all right'
                    startIcon={<SwitchLeftIcon />}
                  >
                    Add All
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant='outlined'
                    size='md'
                    fullWidth={true}
                    onClick={handleCheckedRight}
                    disabled={leftChecked.length === 0}
                    color='primary'
                    aria-label='move selected right'
                    startIcon={<ArrowRightIcon fontSize='large' />}
                  >
                    Add Selection(s)
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant='outlined'
                    size='md'
                    fullWidth={true}
                    onClick={handleCheckedLeft}
                    disabled={rightChecked.length === 0}
                    color='primary'
                    aria-label='move selected left'
                    endIcon={<ArrowLeftIcon fontSize='large' />}
                  >
                    Remove Selection(s)
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant='outlined'
                    size='md'
                    fullWidth={true}
                    onClick={handleAllLeft}
                    disabled={right.length === 0}
                    color='primary'
                    aria-label='move all left'
                    endIcon={<SwitchRightIcon />}
                  >
                    Remove All
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <h5>Templates to Customize</h5>
              {customList(right)}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color='secondary' onClick={props.handleClose}>
            Cancel
          </Button>
          <Button
            disabled={right.length === 0}
            onClick={handleAddParameters}
            color='primary'
          >
            Add Template(s)
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
